/* eslint-disable no-empty-pattern */
/* eslint-disable @typescript-eslint/no-explicit-any */
import style from "./style.module.scss";
import { useRef, useEffect } from "react";
import withHeaderFooter, { IWithHeaderFooterProps } from "@/app/csr-src/hocs/with-header-footer";
import JDILogin from "@/common-components-src/js/newlogin/index.newlogin";
import { Helmet } from "react-helmet";
const Login = withHeaderFooter(({}: IWithHeaderFooterProps) => {
  const loginWrapRef = useRef(null);
  useEffect(() => {
    const _JDILogin: any = JDILogin.getInstance();
    const _W: any = window;
    _JDILogin.getUserInfo().then((res: any) => {
      const urlParams = new URLSearchParams(_W.location.search);
      const returnUrl = urlParams.get("returnUrl");
      if (res.isLoggedIn) {
        if (returnUrl) {
          _W.location.href = returnUrl;
        } else {
          _W.location.href = "/Profile";
        }
        return;
      }
      _JDILogin.renderLoginPage(loginWrapRef && loginWrapRef.current);
    });
  }, []);
  return (
    <div className={style.login__wrap} ref={loginWrapRef}>
      <Helmet>
        <title>Login to Your Account | Joybuy</title>
        <meta
          name="description"
          content="Joybuy offers the best online shopping experience with fast shipping and delivery guarantee on all orders. Shop now for unbeatable deals on top-quality products."
        />
      </Helmet>
    </div>
  );
});

export default Login;
